function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import type from 'type-detect';
var EventRegister = /*#__PURE__*/function () {
  function EventRegister() {
    _classCallCheck(this, EventRegister);
  }
  _createClass(EventRegister, null, [{
    key: "addEventListener",
    value: function addEventListener(eventName, callback) {
      if (type(eventName) === 'string' && type(callback) === 'function') {
        EventRegister._Listeners.count++;
        var eventId = 'l' + EventRegister._Listeners.count;
        EventRegister._Listeners.refs[eventId] = {
          name: eventName,
          callback: callback
        };
        return eventId;
      }
      return false;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(id) {
      if (type(id) === 'string') {
        return delete EventRegister._Listeners.refs[id];
      }
      return false;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      var removeError = false;
      Object.keys(EventRegister._Listeners.refs).forEach(function (_id) {
        var removed = delete EventRegister._Listeners.refs[_id];
        removeError = !removeError ? !removed : removeError;
      });
      return !removeError;
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(eventName, data) {
      Object.keys(EventRegister._Listeners.refs).forEach(function (_id) {
        if (EventRegister._Listeners.refs[_id] && eventName === EventRegister._Listeners.refs[_id].name) EventRegister._Listeners.refs[_id].callback(data);
      });
    }

    /*
     * shortener
     */
  }, {
    key: "on",
    value: function on(eventName, callback) {
      return EventRegister.addEventListener(eventName, callback);
    }
  }, {
    key: "rm",
    value: function rm(eventName) {
      return EventRegister.removeEventListener(eventName);
    }
  }, {
    key: "rmAll",
    value: function rmAll() {
      return EventRegister.removeAllListeners();
    }
  }, {
    key: "emit",
    value: function emit(eventName, data) {
      EventRegister.emitEvent(eventName, data);
    }
  }]);
  return EventRegister;
}();
EventRegister._Listeners = {
  count: 0,
  refs: {}
};
export { EventRegister };